import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  SET_MESSAGE,
  CLEAR_MESSAGE,
  // VERIFIED_TOKEN,
  // UNAUTHENTICATED,
} from "./Types";

import axios from '../../Helpers/Axios';

import JwtService from '../../Core/Services/JwtService';

export const login =  (email, password) => (dispatch) => {
  return axios.post('v1/auth/login', {email, password})
    .then((res) => {
      const { data }  = res;

      if(!data.data.status){

        dispatch({
          type: LOGIN_FAIL,
        });


        return {
          status : false,
          message: data.data
        }

      }

      console.log(data.data.data)
      JwtService.saveToken(data.data.data.token.access_token)

      dispatch({
        type: LOGIN_SUCCESS,
        payload: { user: data.data.data.customer },
      })

      dispatch({
        type: CLEAR_MESSAGE,
      });

      return {
        status : true,
        message: "Login Successful."
      }

      
    }).catch(err => {
      
    });
};

// Register user
export const register = (name, email, password) => (dispatch) => {
	return axios.post('v1/auth/signUp' , {name, email, password})
  .then(res => {
    const { data }  = res;
    if(!data.data.status){

      dispatch({
          type: REGISTER_FAIL,
      })

      return {
        status : false,
        message: data.data
      }
    }

    JwtService.saveToken(data.data.data.token.access_token)

    dispatch({
      type: REGISTER_SUCCESS,
      payload: { user: data.data.data.customer },
    })

    return {
      status : true,
      message: "Signup Successful."
    }

  });
	
};

// Logout User
export const logout = () => (dispatch) => {
  const token = JwtService.getToken();

  return axios.get('v1/auth/logout', {
    headers: {
      'Accept' : 'application/json',
      'Authorization' : `Bearer ${token}`
    }
  })
    .then(res => {
      const { data }  = res;
      if(data.status){
        JwtService.destroyToken()

        dispatch({
          type: LOGOUT
        })
        return {
          status : true,
          message: "Logout Successful."
        }
      }
    })
};

// Verify Token
export const verifyToken =  async (token) => {
  return axios.get('v1/auth/verifyToken', {
    headers: {
      'Accept' : 'application/json',
      'Authorization' : `Bearer ${token}`
    }
  })
}
// export const verifyToken = () => (dispatch) => {
//   const token = JwtService.getToken();
//   return axios.get('v1/auth/verifyToken', {
//     headers: {
//       'Accept' : 'application/json',
//       'Authorization' : `Bearer ${token}`
//     }
//   })
//     .then(res => {
//       const { data }  = res;
//       if(!data.status){
//         dispatch({
//           type: UNAUTHENTICATED,
//         })

//         return {
//           status : false,
//           message: "Unauthenticated."
//         }
//       }

//       dispatch({
//         type: VERIFIED_TOKEN,
//         payload: data.user
//       })
      
//       return {
//         status : true,
//         message: "Yes!"
//       }

//     })
// }

// Change Password
export const changePassword = async (oldPassword, newPassword) => {
  const token    = await JwtService.getToken();

  const { data } =  await axios.post('v1/auth/change-password',{
    old_password : oldPassword,
    new_password : newPassword
  }, {
    headers: {
      'Accept' : 'application/json',
      'Authorization' : `Bearer ${token}`
    }
  })

  return data

}

// Verify Email
export const verifyEmail = async (email) => {

  const { data } =  await axios.post('v1/auth/verify-email', {
    email  : email
  })

  return data

}

// Reset password
export const resetPassword = async (token, email, passowrd, newPassword) => {

  const { data } =  await axios.post('v1/auth/reset-password', {
    token        : token,
    email        : email,
    password     : passowrd,
    password_confirmation : newPassword
  }, {
    headers: {
      'Accept' : 'application/json',
    }
  })

  return data

}

// Change Password
export const changeProfile = async (name, phone, gender, address, bio, dob) => {
  const token    = await JwtService.getToken();

  const { data } =  await axios.post('v1/auth/update-profile',{
    name, phone, gender, address, bio, dob
  }, {
    headers: {
      'Accept' : 'application/json',
      'Authorization' : `Bearer ${token}`
    }
  })

  return data

}